// extracted by mini-css-extract-plugin
export default {"root":"Label_root__3ZR7-","mainText":"Label_mainText__egqSf","optionalText":"Label_optionalText__nK6+N","small":"Label_small__t+1vw"};